import { DateTime } from "luxon";

export const HOUR_IN_SECONDS = 3600;
export const DAY_IN_SECONDS = 86400;

// return relative date using luxon in spanish locale
export const toRelativeDate = (date: string) => {
  return DateTime.fromISO(date).setLocale("es").toRelative();
};

export const dateToSecondsSinceEpoch = (date: Date): number => {
  return date.getTime() / 1000;
};
